import React, { Component } from "react";
import PropTypes from "prop-types";
import { base } from "../base.js";

class ExpireRetro extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      concerns: []
    };
  }

  componentWillMount = () => {
    base.syncState(`${this.props.user.uid}/concerns/`, {
      context: this,
      state: "concerns",
      asArray: true,
      then: this.expireRetro
    });
  };

  sortConcernsByRecency = (obj1, obj2) => {
    if (obj1.createdAt > obj2.createdAt) {
      return -1;
    } else if (obj1.createdAt < obj2.createdAt) {
      return 1;
    } else {
      return 0;
    }
  };

  //NOTE: This function currently is a copy of a function inside Board.js
  expireRetro = () => {
    console.log("expiring retro");
    const concerns = [...this.state.concerns];
    var concernsCompleted = 0;
    var totalConcernsCompleted = 0;

    // Counts queued concerns and then marks them as completed
    concerns.forEach(concern => {
      if (concern.status === "queued") {
        concernsCompleted = concernsCompleted + 1;
        totalConcernsCompleted = totalConcernsCompleted + 1;
        concern.status = "completed";
      } else if (concern.status === "completed") {
        totalConcernsCompleted = totalConcernsCompleted + 1;
      }
    });

    concerns.sort(this.sortConcernsByRecency);

    this.setState({
      concerns: concerns
    });

    const sendEmails = false;
    const expire = true;
    this.props.commitFinishedRetro(
      concernsCompleted,
      totalConcernsCompleted,
      sendEmails,
      expire
    );
  };

  render() {
    return <div>Expiring Outro...</div>;
  }
}

ExpireRetro.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    uid: PropTypes.string.isRequired,
    creationTime: PropTypes.string.isRequired,
    lastSignInTime: PropTypes.string.isRequired,
    photoURL: PropTypes.string
  }).isRequired,
  commitFinishedRetro: PropTypes.func.isRequired
};

export default ExpireRetro;



// WEBPACK FOOTER //
// ./src/components/ExpireRetro.js